import { AppointmentModel, ClassroomModel, LiveModel } from '@descomplica/dex-models';
import { StudyPlanTemplateModel } from './studyPlanTemplateModel';

export enum ActivityType {
  lesson,
  live,
}

export interface Activity {
  id: number;
  type: ActivityType;
}

export interface Lesson extends Activity {
  pedagogicalActivityId: number;
  disciplineId: number;
}

export interface Live extends Activity {
  start: Date;
  end: Date | null;
  classroom: ClassroomModel;
  event?: LiveModel;
}

export interface DateActivities {
  date: string;
  activities: Activity[];
}

export interface WeekActivities {
  week: number;
  dateActivities: DateActivities[];
}

export interface StudyPlanModel extends StudyPlanTemplateModel {
  appointments: AppointmentModel[];
}
